'use strict';
var dropdowns = document.querySelectorAll('.language-switcher');
dropdowns.forEach(function(dropdown) {
    var trigger = dropdown.querySelector('.language-switcher__trigger');
    if (trigger) trigger.addEventListener('click', function() {
        dropdown.classList.toggle('language-switcher--active');
    });
});
document.addEventListener('click', function(e) {
    dropdowns.forEach(function(dropdown) {
        if (!dropdown.contains(e.target)) dropdown.classList.remove('language-switcher--active');
    });
});

//# sourceMappingURL=Museum_2.039a07fd.js.map
